export const typeDefs = `
  input DraftInput {
    id: String!
    raw: String
  }
`;
